import React from 'react'

import { Table, Col, Row } from '_zari/core'

import * as ProductosCrud from 'services/producto.service'

import FilaBusquedaTemplate from './filasTemplates/filaBusqueda'
import FilaDetalleTemplate from './filasTemplates/filaDetalle'

const DetallesSection = ({ detalles, dispatch }) => {
  const rowHeaders = React.useMemo(() => {
    return [
      { label: '#' },
      { label: 'COD' },
      { label: 'DESCRIPCIÓN' },
      { label: 'CANT', width: 70 },
      { label: 'U. MED', width: 80 },
      { label: '' }
    ]
  }, [])

  const prefijoIdFila = React.useRef(1)

  const seleccionarProductoViaBusquedaHandler = React.useCallback(
    productoSeleccionado => {
      ProductosCrud.getProducto_Compras(productoSeleccionado.value).then(({ data }) => {
        prefijoIdFila.current = prefijoIdFila.current + 1

        dispatch({
          type: 'agregar',
          payload: {
            nuevaFila: false,
            viaCodBar: false,
            ...data
          }
        })
      })
    },
    [dispatch]
  )

  const seleccionarProductoViaCodigoBarraHandler = React.useCallback(
    productoSeleccionado => {
      prefijoIdFila.current = prefijoIdFila.current + 1
      dispatch({
        type: 'agregar',
        payload: { nuevaFila: true, viaCodBar: true, ...productoSeleccionado }
      })
    },
    [dispatch]
  )

  const actualizarFilaHandler = React.useCallback(
    data => {
      const { saltarCampo, ...newData } = data
      if (saltarCampo) {
        prefijoIdFila.current = prefijoIdFila.current + 1
      }
      dispatch({ type: 'actualizar', payload: newData })
    },
    [dispatch]
  )

  const eliminarFilaHandler = React.useCallback(
    _idFila => {
      prefijoIdFila.current = prefijoIdFila.current + 1
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  const rowTemplate = React.useCallback(
    (row, key) => {
      if (row.esFilaBusqueda) {
        return <React.Fragment key={key} />
      } else {
        return (
          <FilaDetalleTemplate
            index={key}
            key={`${prefijoIdFila.current}${key}filaDetalle`}
            row={row}
            actualizarFilaHandler={actualizarFilaHandler}
            eliminarFilaHandler={eliminarFilaHandler}
          />
        )
      }
    },
    [actualizarFilaHandler, eliminarFilaHandler]
  )

  const filaBusquedaInfo = React.useMemo(() => {
    return detalles.find(x => x.esFilaBusqueda)
  }, [detalles])

  return (
    <>
      <Row>
        <Col md={12}>
          <Table
            maxRowsShown={5}
            filas={detalles}
            headRows={rowHeaders}
            rowTemplate={rowTemplate}
          />
        </Col>
      </Row>
      {filaBusquedaInfo && (
        <Row style={{ marginBottom: '3.5rem' }}>
          <Col md={12}>
            <FilaBusquedaTemplate
              key={`${prefijoIdFila.current}filaBusqueda`}
              esFilaActiva={filaBusquedaInfo.__filaActiva}
              seleccionarProductoViaBusquedaHandler={seleccionarProductoViaBusquedaHandler}
              seleccionarProductoViaCodigoBarraHandler={seleccionarProductoViaCodigoBarraHandler}
            />
          </Col>
        </Row>
      )}
    </>
  )
}

export default DetallesSection
